import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rolePipe'
})
export class RolePipePipe implements PipeTransform {

  transform(value: any, role:string): any {
    const roles:any[] = value.roles;
    if(!roles) return false;
    const values:string[] = Object.keys(roles[0]).map(key => roles[0][key]);
    return values && values.includes(role);
  }

  transformByRole(value: any): string {
    const roles:any[] = value.roles;
    if(!roles) return "";
    const values:string[] = Object.keys(roles[0]).map(key => roles[0][key]);
    return values[0];
  }

}
